<div class="dashboard-card">
  <div class="card-header">
    <h4 class="card-title">Consumption Trend</h4>
  </div>
  <div class="card-content">
    <div *ngIf="isLoadingConsumptionTrend" class="card-loading">
      <div class="loading-spinner"></div>
      <span>Loading consumption trend...</span>
    </div>
    <div *ngIf="!isLoadingConsumptionTrend && isEmptyTrendData()" class="empty-state-message">
      <i class="fa fa-area-chart empty-icon" aria-hidden="true"></i>
      <span>No consumption trend data available for the selected date range.</span>
    </div>
    <canvas #chart1 class="chart-canvas" [style.display]="isLoadingConsumptionTrend || isEmptyTrendData() ? 'none' : 'block'"></canvas>
  </div>
</div>
